import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import s from './AdminLayout.module.css';
import { AdminHeader } from '../AdminHeader/AdminHeader';
import { AdminSidebar } from '../AdminSidebar/AdminSidebar';

export const AdminLayout: React.FC = () => {
    const [sidebarOpen, setSidebarOpen] = useState(false);

    return (
        <div className={s.adminLayout}>
            <AdminHeader onBurgerClick={() => setSidebarOpen(!sidebarOpen)} />
            <AdminSidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
            <main className={s.adminContent}>
                <Outlet />
            </main>
        </div>
    );
};